export type PrimaryPalette =
  | "slate"
  | "navy"
  | "forest"
  | "crimson"
  | "indigo"
  | "rose"
  | "teal"
  | "amber"
  | "charcoal"
  | "cobalt";

export type AccentPalette =
  | "gold"
  | "coral"
  | "emerald"
  | "cobalt"
  | "violet"
  | "orange"
  | "lime"
  | "sky";

export type SurfaceStyle = "light" | "warm" | "cool" | "dark";

export type FontPairing =
  | "classic"
  | "editorial"
  | "geometric"
  | "humanist"
  | "professional";

export type ButtonRadius = "square" | "rounded";

export type DesignTokenOverrides = {
  primary_palette?: PrimaryPalette;
  accent_palette?: AccentPalette;
  surface_style?: SurfaceStyle;
  font_pairing?: FontPairing;
  button_radius?: ButtonRadius;
};

export type DesignUpdate = {
  design_updates: DesignTokenOverrides;
  design_config: DesignTokenOverrides;
};

// Client-side palette colour map — mirrors DesignPalette in Rails
export const PRIMARY_HEX: Record<PrimaryPalette, string> = {
  slate: "#475569",
  navy: "#1e3a5f",
  forest: "#166534",
  crimson: "#9b1c1c",
  indigo: "#3730a3",
  rose: "#be185d",
  teal: "#0f766e",
  amber: "#92400e",
  charcoal: "#1f2937",
  cobalt: "#1d4ed8",
};

export const ACCENT_HEX: Record<AccentPalette, string> = {
  gold: "#f59e0b",
  coral: "#f43f5e",
  emerald: "#059669",
  cobalt: "#2563eb",
  violet: "#7c3aed",
  orange: "#ea580c",
  lime: "#65a30d",
  sky: "#0284c7",
};

export const SURFACE_BG_HEX: Record<SurfaceStyle, string> = {
  light: "#f8fafc",
  warm: "#fdfaf5",
  cool: "#f0f9ff",
  dark: "#0f172a",
};

export const FONT_DISPLAY_NAMES: Record<
  FontPairing,
  { heading: string; body: string }
> = {
  classic: { heading: "Plus Jakarta Sans", body: "Inter" },
  editorial: { heading: "Playfair Display", body: "Lato" },
  geometric: { heading: "Syne", body: "DM Sans" },
  humanist: { heading: "Raleway", body: "Nunito" },
  professional: { heading: "Roboto Slab", body: "Source Sans 3" },
};

export const BUTTON_RADIUS_LABELS: Record<ButtonRadius, string> = {
  square: "Square corners",
  rounded: "Rounded corners",
};

/** User-facing labels for site background / light–dark mode (`surface_style` token). */
export const SURFACE_STYLE_LABELS: Record<SurfaceStyle, string> = {
  light: "Light mode",
  warm: "Warm background",
  cool: "Cool background",
  dark: "Dark mode",
};
